import axios from "axios";

// Production
export const publicUrl = "https://res.cloudinary.com/ahmad-clouds/image/upload";
export const ebookUrl = "https://res.cloudinary.com/ahmad-clouds/raw/upload";
export const baseBackendUrl = "https://libraryapp-api.herokuapp.com/api/v1";

// Development
// export const publicUrl = "http://localhost:4000";
// export const baseBackendUrl = "http://localhost:4000/api/v1";

// Axios Default Url
export const API = axios.create({
  baseURL: baseBackendUrl,
});

// Set Auth Token
export const setAuthToken = (token) => {
  if (token) {
    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete API.defaults.headers.common["Authorization"];
  }
};

export const headerConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};
